<template>
  <div id="app" :style="{'font-size':''+valorFont+'px'}">
    <v-app>
      <v-main fluid >
        <header-app @accionAcce="accionBoton" />
        <slider-app v-if="$route.path == '/'" />
        <navUser :cambiarPosicion="posnav" id="navusercont"/>
        <transition>
          <router-view class="cont-general" :key="$store.state.idContenido">
          </router-view>
         </transition>
        <footer-app class="cont-footer"/>
     </v-main>
    </v-app>
  </div>
</template>

<script>
import sliderApp from './components/slider'
import headerApp from './components/header'
import footerApp from './components/footer'
import followApp from './components/follow'
import modalApp from './components/modal'
import navUser from './components/nav-user'

export default {
  name: 'App',
  components: {
    sliderApp,
    headerApp,
    footerApp,
    // followApp,
    // modalApp,
    navUser
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'EAAV',
    // all titles will be injected into this template
    titleTemplate: '%s | Estamos para servirte'
  },
  data () {
    return {
      valorFont: 13,
      posnav: false,
      topNav: null
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted () {
    // console.log(this.$route.path)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      let navItem = document.getElementById('navusercont')
      this.topNav = navItem.offsetTop
      // console.log(this.topNav)
      let actualScroll = window.scrollY
      // console.log('Se activo', window.scrollY)
      if (actualScroll >= this.topNav) {
        this.posnav = true
      } else {
        this.posnav = false
      }
    },
    accionBoton (val) {
      if (val === 'aumentarTexto') {
        this.aumentar()
      } else if (val === 'reducirTexto') {
        this.disminuir()
      } else if (val === 'restablecerTexto') {
        this.restablecer()
      }
      // console.log(this.valorFont)
    },
    aumentar () {
      if (this.valorFont >= 25) {
        this.valorFont = 25
      } else {
        this.valorFont = this.valorFont + 0.4
      }
    },
    disminuir () {
      if (this.valorFont <= 12) {
        this.valorFont = 12
      } else {
        this.valorFont = this.valorFont - 0.4
      }
    },
    restablecer () {
      this.valorFont = 12
    }
  }
}
</script>
<style lang="scss">
@import 'src/scss/globals';
#app{
  width: 100%;
  font-family: "CenturyGothic";
  // font-size: 13px;
  margin: 0px;
  padding: 0px;
  .cont{
    @media (max-width: 900px) {
    }
  }

}

.fill-viewport-height {
  height: 100vh; //Antes estaba 100% pero no funcionaba en navegadores iOS
}

button:focus{
  outline: none!important;
}

/********************  FONTS ********************/
/* Las fuentes se cargan acá porque se tiene acceso a los recursos que están en assets*/

@font-face {
  font-family: CenturyGothic;
  src: url("../src/assets/fonts/CenturyGothic.ttf");
  font-weight: normal;
}
// .cont-general{
//   padding-bottom: 500px;
// }
.cont-footer{
  margin-top: 0px;
}
</style>
